<script setup>
import { useRoute } from 'vue-router';
import { computed, ref } from 'vue';
import FordButton from '@/components/FordButton.vue';
import RegistrationModal from '@/components/modal/RegistrationModal.vue';
import InPersonVirtualTemplate from '@/components/events/InPersonVirtualTemplate.vue';
import AppointmentModal from './appointmentModal/AppointmentModal.vue';
import pages from './appointmentModal/pages';

const props = defineProps({
  event: Object,
});

const emit = defineEmits(['registered']);

// Sat Sept 13, 2022
// const formatDate = (dateString) => dayjs(dateString).format('ddd MMM D, YYYY');

const isFordProOwned = computed(() => !props.event?.thirdPartyOwned);

const route = useRoute();

const showRegistrationModal = ref(route?.params.register === 'register');

const toggleRegistrationModal = () => {
  showRegistrationModal.value = !showRegistrationModal.value;
};

const sessionId = ref(route?.params.sessionid); // email link for reschedule, cancel
const initialLaunchAppointmentModal = ref(!!sessionId.value);
const showAppointmentModal = ref(initialLaunchAppointmentModal.value);

const clearSessionId = () => { // clear from appointment-modal and from browser url
  sessionId.value = undefined;
  const sliceAt = window.location.href.indexOf('reschedule') - 1;
  if (sliceAt > 0) {
    window.history.replaceState(null, '', window.location.href.slice(0, sliceAt));
  }
};

const toggleAppointmentModal = () => {
  showAppointmentModal.value = !showAppointmentModal.value;

  if (showAppointmentModal.value === false) { // clear email link
    clearSessionId();
    initialLaunchAppointmentModal.value = undefined;
  }
};
</script>
<template>
  <appointment-modal v-if="showAppointmentModal"
    :event="event"
    :session-id="sessionId"
    :initialPage="initialLaunchAppointmentModal ? pages.rescheduleCancel : undefined"
    @clear-session-id="clearSessionId"
    @close="toggleAppointmentModal"
  />
  <registration-modal v-if="showRegistrationModal"
    :id="event?.id"
    :showQuestion="event?.showQuestionFieldOnRegistration"
    @close="toggleRegistrationModal"
    @registered="() => emit('registered')" />
  <in-person-virtual-template :event="event">
    <template v-slot:hero-details>
      <div class="mb-[1.5rem] hidden tablet:block">
        <slot name="hero-details"></slot>
      </div>
    </template>
    <template v-slot:hero-button>
      <div
        class="
          grid
          grid-cols-1 desktop:grid-cols-2
          gap-[1.875rem] desktop:gap-[2.5rem]
        ">
        <ford-button v-if="isFordProOwned"
          @method="toggleRegistrationModal"
          invert min-width="190" class="opacity-[.85]">
          {{ event.ctaLabel }}
        </ford-button>
        <ford-button v-if="event?.configSME"
          @method="toggleAppointmentModal"
          invert min-width="190" class="opacity-[.85]">
          {{ event?.configSME?.callToActionText }}
        </ford-button>
      </div>
    </template>
    <template v-slot:info-details>
      <slot name="info-details"></slot>
    </template>
    <template v-slot:info-area-button>
      <ford-button v-if="isFordProOwned"
        @method="toggleRegistrationModal"
        class="mb-[2rem]"
        transparent
        ariaLabel="Register for the Event">
        {{ event?.ctaLabel }}</ford-button>
      <div v-else
        class="
          w-[12rem]
          rounded-full
          py-2
          font-FordAntennaCondReg
          desktop:text-lg
          bg-ford-blue-dark
          text-white
          border border-ford-blue-dark
          text-center
          cursor-pointer
        "
      >
        <a
          :href="event?.ctaExternalLink"
          aria-label="Learn more about the event"
          target="_blank">
          <div class="title-container">{{ event?.ctaLabel }}</div>
        </a>
      </div>
    </template>
  </in-person-virtual-template>
</template>
